import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PatientTable from "./PatientTable";
import "../../common/Common.css";
import { useSelector } from "react-redux";
import api from "../../services/api";

// ---- shared palette (matches PatientTable.js) ---------------------------
const palette = {
  teal: "#4B49AC",
  tealDark: "#37357D",
  tealSoft: "#EEEDF9",
  ink: "#1F2937",
  slate: "#6B7280",
  line: "#E6E9ED",
  bg: "#FAFBFC",
  coral: "#FF6B57",
  coralSoft: "#FFEFEC",
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="branch_tab"
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
    className: "branch_tab",
  };
}

export default function PatientsComponent({ userDetail }) {
  const [value, setValue] = React.useState(0);
  const [patientDetails, setPatientDetails] = React.useState([]);
  const WS_URL = process.env.REACT_APP_WS_URL;
  const branch = useSelector((state) => state.userDetails.detail?.branches);

  React.useEffect(() => {
    getPatientDetails();
    initWebSocket();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getPatientDetails = async () => {
    let patientData = await api.get(`app/patient/`, {});
    setPatientDetails(patientData?.data);
  };

  const initWebSocket = () => {
    const ws = new WebSocket(`${WS_URL}/ws`);
    ws.onopen = () => {
      console.log("Connected to WebSocket ✅");
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.event === "patient_created") {
          getPatientDetails();
        }
      } catch (err) {
        console.error("Error parsing WS message", err);
      }
    };

    ws.onclose = () => {
      console.log("WebSocket disconnected");
    };

    return ws; // if you want to use it later
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: `1px solid ${palette.line}`,
          marginBottom: "20px",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="branch tabs"
          TabIndicatorProps={{
            sx: { backgroundColor: palette.teal, height: "3px", borderRadius: "3px 3px 0 0" },
          }}
          sx={{
            minHeight: "42px",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "13.5px",
              color: palette.slate,
              minHeight: "42px",
              padding: "8px 18px",
              "&:hover": { color: palette.tealDark },
            },
            "& .Mui-selected": {
              color: `${palette.teal} !important`,
            },
          }}
        >
          {branch?.map((b, index) => (
            <Tab
              key={b.id}
              label={b.name}
              {...a11yProps(index)}
              className="branch_name"
            />
          ))}
        </Tabs>
      </Box>
      {branch?.map((b, index) => (
        <CustomTabPanel key={b.id} value={value} index={index}>
          <PatientTable
            rows={patientDetails[b.id]}
            branchId={b.id}
            patientDetails={patientDetails}
            getPatientDetails={getPatientDetails}
            userDetail={userDetail}
          />
        </CustomTabPanel>
      ))}
    </Box>
  );
}